__turbopack_context__.v({
  "content": "modal-content-module-scss-module__mW4_IW__content",
  "placeholder": "modal-content-module-scss-module__mW4_IW__placeholder",
});
